export default __webpack_public_path__ + "static/media/locate_icon.f48952df.svg";